export enum BlobContainer {
    Private,
    Public,
}

export enum ErrorCodes {
    Generic = 0,

    ValidationError = 210,

    // tech
    NoConnection = 600,
    NormailizeAudio = 601,
    CookieTestFailed = 602,
    LocationServiceOffline = 603,
    InvalidAudience = 604,
    InvalidClaim = 605,
    InvalidVersion = 606,
    ServiceUnavailable = 607,
}

export enum UserRoles {
    None = 1 << 0, // 1
    User = 1 << 1, // 2
    Administrator = 1 << 3, // 4
}

export enum ProductType{
    BagelBox = 0,
    BagelSleeve,
    CreamCheese,
}

export enum NavigationState {
    Closed,
    Open,
}

export enum PaymentStatus {
    None = 0,
    Cancelled,
    Pending,
    Complete,
    Refunded,
}

export enum OrderStatus {
    Inactive = 0,
    Pending,
    Active,
    Completed,
    Canceled,
}

export enum Status {
    Inactive = 0,
    Active = 1,
}
